export default "__VITE_ASSET__47687769__"